"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CasingType = void 0;
var CasingType;
(function (CasingType) {
    CasingType["flat"] = "flat";
    CasingType["camel"] = "camel";
    CasingType["pascal"] = "pascal";
    CasingType["kebab"] = "kebab";
    CasingType["cobol"] = "cobol";
    CasingType["snake"] = "snake";
    CasingType["macro"] = "macro";
})(CasingType = exports.CasingType || (exports.CasingType = {}));
//# sourceMappingURL=types.js.map